import { useNavigate } from "react-router-dom";
import { FormEvent, useCallback, useState } from "react";
import { createUser } from "../../firebase";
import { ErrorToast } from "./error-toast";
import { AuthError } from "@firebase/auth";

export const Signup = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();

  const handleSignUp = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      createUser(email, password)
        .then(() => {
          navigate("/verify-email");
        })
        .catch((error: AuthError) => {
          setError(error.code);
        });
    },
    [email, password, navigate]
  );

  return (
    <div className="food xs:mt-16 xs:rounded shadow-xl mx-auto p-4 xs:max-w-sm">
      {error ? (
        <ErrorToast message={error} onDismiss={() => setError(null)} />
      ) : null}
      <form onSubmit={handleSignUp}>
        <div className="w-full flex justify-center items-center">
          <h1 className="text-xl font-bold text-white mb-6">
            Nieuwe gebruiker
          </h1>
        </div>
        <div className="mb-6">
          <label className="box-input-label mb-2" htmlFor="form-email">
            Email
          </label>
          <input
            className="box-input mb-3"
            id="form-email"
            type="text"
            value={email}
            onChange={(event) => {
              setEmail(event.currentTarget.value);
            }}
            placeholder="jouw@email.nl"
          />
        </div>
        <div className="mb-6">
          <label className="box-input-label mb-2" htmlFor="form-password">
            Wachtwoord
          </label>
          <input
            className="box-input mb-3"
            id="form-password"
            type="password"
            value={password}
            onChange={(event) => {
              setPassword(event.currentTarget.value);
            }}
            placeholder="********"
          />
        </div>
        <button className="btn-primary mb-12">
          <i className="fa fa-user mr-2 fa-2x" />
          <span>Registreren</span>
        </button>
      </form>
      <button
        onClick={() => {
          navigate("/login");
        }}
        className="btn-secondary mb-6"
      >
        <i className="fa fa-sign-in-alt mr-2 fa-2x" />
        <span>Terug naar inloggen</span>
      </button>
    </div>
  );
};
